"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgVoucher(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M26.3 16a3 3 0 01-.6-1.3 3 3 0 012.3-3.6L27.5 9c-.3-1.3-1.5-2-2.8-1.8L5.2 11.5a2.3 2.3 0 00-1.8 2.8l.6 2.2c1.6-.4 3.3.6 3.7 2.2.2.8 0 1.5-.3 2.2a3 3 0 01-2 1.4l.5 2.3c.3 1.2 1.5 2 2.7 1.7L10 26", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M26.3 16l8.4 1.5a2 2 0 011.6 2.3l-.5 2.6c-1.7-.3-3.3.7-3.7 2.4a3 3 0 002.5 3.5l-.5 2.6a2 2 0 01-2.3 1.5l-20.3-3.7a2 2 0 01-1.6-2.3V26l.5-2.2c1.7.4 3.3-.7 3.6-2.3a3 3 0 00-2.5-3.6l.5-2.5a2 2 0 012.3-1.6l12 2.2v0z", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M16.8 24l11.8 2M17.6 20.2l11.7 2", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0)] }), void 0));
}
exports.default = SvgVoucher;
//# sourceMappingURL=Voucher.js.map